<template>
  <img :class="className" :src="require(`@/assets/images/${src}`)" :alt="alt">
</template>

<script>
export default {
  name: 'ImageElement',
  props: {
    className: String,
    src: String,
    alt: String
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
img {
  display: inline-block;
  height: auto;
  max-height: 100%;
  max-width: 100%;
  width: auto;
}
</style>
